import { MessageMedium, WhatsApp } from 'constants/messageMediums';

const SHORT_LINK_COMPATIBLE_MEDIUMS = [MessageMedium.SMS, WhatsApp];

export const isMediumShortLinkCompatible = (medium: MessageMedium) =>
  SHORT_LINK_COMPATIBLE_MEDIUMS.includes(medium);
